import React from 'react'
import { CodeOutlined } from '@ant-design/icons'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { Dropdown, DropdownProps, Menu, MenuProps } from 'src/antd'
import styled from 'styled-components'

import ControlBarButton from './ControlBarButton'
import { TX_INSERT_VARIABLES } from '../../../transifex'
import { CssScroller } from '../../CssScroller'

const DropdownOverlayClassname = ({
  className,
  ...props
}: DropdownProps & { className?: string }) => (
  <Dropdown {...props} overlayClassName={className} />
)

const ScrollDropdown = styled(DropdownOverlayClassname)`
  .ant-dropdown-menu {
    max-height: 300px;
    overflow-y: scroll;
    ${CssScroller}
  }
`

type VariableProps = {
  variables: ItemType[]
  onVariableClick?: MenuProps['onClick']
}

const Variables = ({ variables, onVariableClick }: VariableProps) => {
  return (
    <ScrollDropdown
      placement="bottomRight"
      dropdownRender={() => (
        <Menu onClick={onVariableClick} items={variables} />
      )}
      trigger={['click']}
    >
      <ControlBarButton tooltip={TX_INSERT_VARIABLES} icon={<CodeOutlined />} />
    </ScrollDropdown>
  )
}

export default Variables
